var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.009,
    height: 35,
    viewBox: "0 0 35.009 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M32.938,28.789l12.5-12.5A2.93,2.93,0,1,0,41.3,12.141l-12.5,12.5-12.5-12.5a2.93,2.93,0,1,0-4.144,4.144l12.5,12.5-12.5,12.5a2.93,2.93,0,0,0,4.144,4.144l12.5-12.5,12.5,12.5a2.93,2.93,0,1,0,4.144-4.144Z",
    transform: "translate(-11.285 -11.289)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.19fee4e0.svg";
export { ForwardRef as ReactComponent };